<template>
    <div v-if="!selectedItem" class="container">
        <div class="header">
            <div class="heading">
                <p class="title">User Management</p>
            </div>
            <p class="download" @click="downloadAllAdvertisers"> All Advertisers </p>
        </div>
        <div class="userManagement">
            <div v-if="apiErrorMessage">
                <div class="errorHeading">Error</div>
                <div class="apiErrorMessage">{{ apiErrorMessage }}</div>
            </div>
            <div class="subHeading">
                <select v-model="userType" class="selectInput">
                    <option selected value=""> Select user type </option>
                    <option v-for="role in Object.keys(roles)" v-bind:key="role" :value="role">{{roles[role]}}</option>
                </select>
                <select v-model="status" class="selectInput" style="margin-left: 16px">
                    <option selected value=""> Status </option>
                    <option v-for="type in statuses" v-bind:key="type" :value="type">{{type}}</option>
                </select>
            </div>
            <table class="table">
                <thead style="background: #F5F5F5">
                    <tr>
                        <th class="tableHead">Name</th>
                        <th class="tableHead">User Type</th>
                        <th>Email</th>
                        <th>Added by</th>
                        <th>
                            Timestamp <img alt="img" class="pointer" @click="onSortClick" src="../../assets/Vector.svg" />
                        </th>
                        <th>Brand list</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in filteredItems" :key="item.id">
                        <td>
                            <div style="font-size: 12px; font-weight: 600; color: #41434C"> {{ item.name }} </div>
                        </td>
                        <td>{{ roles[item.role] }}</td>
                        <td>{{ item.email }}</td>
                        <td>{{ item.addedBy }}</td>
                        <td>{{ formatDate(item.timestamp) }}</td>
                        <td v-if="item.role === 'AGENCY'">{{ item.brandDetails?.length }} Brands <img alt="img" class="pointer" @click="onDownloadBrand(item)" src="../../assets/downloadIcon.svg" /></td>
                        <td v-else>-</td>
                        <td>
                            <button class="status" :style="`border: 1px solid ${getColor(item.accountStatus)}; color: ${getColor(item.accountStatus)}`"> 
                                {{item.accountStatus}}
                            </button>
                        </td>
                        <td>
                            <img v-if="role == 'SUPERADMIN' ? (item.accountStatus != 'REJECTED' && item.accountStatus != 'PENDING') : (item.role === 'AGENCY' && item.accountStatus == 'REJECTED')" class="pointer" @click="onEditClick(item)" src="../../assets/editIcon.svg" alt="edit"> 
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="paginate">
                <div class="rows">
                    <span class="paginationText">Page {{ currentPage }} of {{ isNaN(totalPages) ? 1 :
                        totalPages }}</span>
                    <div class="flexClass">
                        <p class="paginationText">Rows per page</p>
                        <select class="limit" v-model="rowsPerPage" @change="onRowsPerPageChanged">
                            <option v-for="option in [10, 20, 50, 100]" v-bind:key="option" :value="option">{{ option }}
                            </option>
                        </select>
                        <img alt="img" v-if="currentPage > 1" @click="prevPage" class="leftArrow"
                            src="../../assets/leftArrow.svg" />
                        <img alt="img" v-else class="leftArrowDisabled" src="../../assets/leftArrow.svg" />
                        <img alt="img" v-if="currentPage < totalPages" @click="nextPage" class="rightArrow"
                            src="../../assets/rightArrow.svg" />
                        <img alt="img" v-else class="leftArrowDisabled" src="../../assets/rightArrow.svg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Onboarding v-else-if="role == 'OPS'" :editMode="!!selectedItem" :item="selectedItem" @backClicked="onBackClick" />
    <UserEdit v-else :item="selectedItem" @backClicked="onBackClick" />
</template>

<script>
import { roleTypes } from "@/constants"
import { getCookie } from "@/services/campaignService"
import { downloadAllProfileDetails, getUserManagementDetails, getUserProfileDetails } from "@/services/selfServeService"
import moment from "moment"
import { toRaw } from "vue"
import Onboarding from "./Onboarding"
import UserEdit from "./UserEdit"

export default ({
    name: 'UserManagement',
    components: {
        Onboarding,
        UserEdit
    },
    data() {
        return {
            roles: roleTypes,
            userType: '',
            statuses: ['APPROVED', 'REJECTED', 'PENDING', 'REVOKED', 'REACTIVATED'],
            status: "",
            items: [],
            currentPage: 1,
            rowsPerPage: 10,
            options: [10, 20, 50, 100],
            filterChanged: false,
            filteredData: [],
            sortClicked: false,
            selectedItem: "",
            role: '',
            apiErrorMessage: null
        }
    },
    mounted() {
        this.getList();
        this.role = getCookie('role');
    },
    methods: {
        getColor(status) {
            if(status == 'APPROVED' || status == 'REACTIVATED') return '#0A5F23'
            else if(status == 'REJECTED' || status == 'REVOKED') return '#CD0909'
            else if(status == 'PENDING') return '#F5A300'
            return '#000'
        },
        formatDate(value) {
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss');
            }
            return value
        },
        onSortClick() {
            this.sortClicked = !this.sortClicked;
            this.filteredData?.sort((a, b) => {
                    let dateA = new Date(a.timestamp) ;
                    let dateB = new Date(b.timestamp) ;
                    return this.sortClicked ? dateB - dateA :  dateA - dateB;
            })
        },
        nextPage() {
            this.currentPage++
        },
        prevPage() {
            this.currentPage--
        },
        async getList() {
            this.apiErrorMessage = null;
            await getUserManagementDetails()
                .then(res => res.json())
                .then(data => {
                    if(data.code == 200) {
                        this.items = data?.data;
                        this.filteredData = data?.data;
                    } else {
                        this.apiErrorMessage = data?.errors?.[0] || data?.message || 'Something went wrong';
                    }
                })
                .catch(error => {
                    this.apiErrorMessage = error?.errors?.[0] || error?.message || 'Something went wrong';
                })
        },
        onEditClick(item) {
            this.apiErrorMessage = null;
            if(this.role == 'SUPERADMIN') {
                this.selectedItem = item;
            } else {
                getUserProfileDetails(item.email)
                    .then(res => res.json())
                    .then(data => {
                        if(data.code == 200) {
                            this.selectedItem = data?.data;
                        } else {
                            this.apiErrorMessage = data?.errors?.[0] || data?.message || 'Something went wrong';
                        }
                    })
                    .catch(error => {
                        this.apiErrorMessage = error?.errors?.[0] || error?.message || 'Something went wrong';
                    })
            }
        },
        onBackClick() {
            this.selectedItem = "";
            this.userType = "";
            this.status = "";
            this.getList();
        },
        onDownloadBrand(user) {
            const headers = {agencyName: 'Agency Name', agencyEmail: 'Agency Email', brandId: 'Brand ID', brandName: 'Brand Name'};
            const data = [headers, ...user?.brandDetails?.map(item => ({agencyName: user.name, agencyEmail: user.email, brandId: item.brandId, brandName: item.brandName}))]
            const csvContent = "data:text/csv;charset=utf-8," +
            data?.map(row => Object.values(row).join(',')).join('\n');
            const link = document.createElement('a');
            link.href = encodeURI(csvContent);
            link.target = '_blank';
            link.download = `${user.name}.csv`;
 
            link.click();
        },
        downloadAllAdvertisers() {
            this.apiErrorMessage = null;
           downloadAllProfileDetails()
                .then(res => res.json())
                .then(data => {
                    if(data.code == 200) {
                        const headers = {role: 'Entity Type', profileId: 'Entity Id', name: 'Entity Name', email: 'Entity Email'};
                        const rows = [headers, ...data?.data]
                        const csvContent = "data:text/csv;charset=utf-8," + rows?.map(row => Object.values(row).join(',')).join('\n');
                        const link = document.createElement('a');
                        link.href = encodeURI(csvContent);
                        link.target = '_blank';
                        link.download = `all_advertisers.csv`;
            
                        link.click();
                    } else {
                        this.apiErrorMessage = data?.errors?.[0] || data?.message || 'Something went wrong';
                    }
                })
                .catch(error => {
                    this.apiErrorMessage = error?.errors?.[0] || error?.message || 'Something went wrong';
                })
        }
    },
    computed: {
        totalPages() {
            let newpages = 0;
            if (this.filterChanged) {
                newpages = Math.ceil(toRaw(this.filteredData)?.length / this.rowsPerPage)
            } else {
                newpages = Math.ceil(toRaw(this.items)?.length / this.rowsPerPage)
            }

            if (this.currentPage !== 1 && this.currentPage > this.totalPages) {
                this.currentPage = this.totalPages;
            }
            newpages = Math.max(newpages, 1);
            return newpages;
        },
        filteredItems() {
            let pageNumber = this.currentPage === 0 ? 1 : this.currentPage;
            const start = (pageNumber - 1) * this.rowsPerPage;
            const end = start + this.rowsPerPage;
            return this.filteredData?.slice(start, end);
        },
        onRowsPerPageChanged() {
            const oldRowsPerPage = this.rowsPerPage;
            this.rowsPerPage = Number(event.target.value);
            this.totalPages = Math.ceil(this.campaigns?.length / this.rowsPerPage);
            if (this.currentPage > this.totalPages) {
                this.currentPage = this.totalPages;
            }
            if (oldRowsPerPage !== this.rowsPerPage) {
                this.$nextTick(() => {
                    const newPage = Math.floor(((this.currentPage - 1) * oldRowsPerPage) / this.rowsPerPage) + 1;
                    this.currentPage = newPage;
                });
            }
        }
    },
    watch: {
        userType() {
            this.currentPage = 1;
            this.filterChanged = !!this.userType || !!this.status;
            this.filteredData = this.items.filter(item => 
                (!this.userType || item.role === this.userType) &&
                (!this.status || item.accountStatus === this.status)
            );
        },
        status() {
            this.currentPage = 1;
            this.filterChanged = !!this.userType || !!this.status;
            this.filteredData = this.items.filter(item =>
                (!this.status || item.accountStatus === this.status) &&
                (!this.userType || item.role === this.userType)
            );
        },
    }
})
</script>

<style scoped>
    .container {
        font-family: 'Inter-Regular';
        background: #F8F8F8;
        display: flex;
        flex-direction: column;
    }
    .header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
        color: #401D0C;
        padding: 8px 20px 0px;
        margin-left: 0;
        background: #FFFFFF;
    }
    .title{
        margin-left:20px;
    }

    .heading {
        display: flex;
        flex-direction: row;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 140%;
        color: #333333;
        margin: 0;
    }
    .userManagement {
        display: flex;
        flex-direction: column;
        margin: 1%;
        text-align: start;
        background: #FFFFFF;
        padding: 22px 24px 36px;
        border-radius: 12px;
    }
    .subHeading {
        display: flex;
    }
    .selectInput {
        width: 200px;
        height: 40px;
        padding: 8px 12px 8px 12px;
        border-radius: 4px 0px 0px 0px;
        border: 1px solid #E0E0E0;
        font-family: Inter-Regular;
        font-size: 12px;
        font-weight: 400;
        line-height: 19.2px;
        text-align: left;
    }
    table {
        border-collapse: collapse;
        margin: 20px 0;
        font-size: 18px;
        display: block;
        overflow: scroll;
    }

    th {
        color: #41434C;
        padding: 12px 15px;
        /* width: 150px; */
        font-size: 14px;
        font-weight: 600;
    }
    td {
        padding: 12px 15px;
        height: 40px;
        font-size: 14px;
        font-weight: 400;
        color: #5C5C5C;
        width: 150px;
    }

    thead tr {
        text-align: left;
        font-weight: bold;
    }

    tbody tr {
        border-bottom: 1px solid #dddddd;
    }

    tbody tr:nth-of-type(even) {
        background-color: #F5F8FF;
    }
    .paginate {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 16px 24px;
        gap: 715px;
        height: 66px;
        left: 274px;
        top: 775px;
        background: #FFFFFF;
        border: 1px solid #F8F8F8;
        width: -webkit-fill-available;
    }
    .rows {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.flexClass {
    display: flex;
}

.limit {
    display: flex;
    margin-left: 20px;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #666666;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    padding: 10px 8px 10px 12px;
}

.leftArrow {
    display: flex;
    margin-left: 24px;
    cursor: pointer;
}

.leftArrowDisabled {
    display: flex;
    margin-left: 20px;
    opacity: 0.4;
    cursor: not-allowed;
}

.rightArrow {
    display: flex;
    margin-left: 20px;
    cursor: pointer;
}
.paginationText {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #9B9B9B;
}
.status {
        width: 91px;
        height: 21px;
        padding: 1px 4px 1px 4px;
        border-radius: 4px;
        font-size: 12px;
        background: #fff;
    }
    .pointer {
        cursor: pointer;
    }
.download {
    cursor: pointer;
    margin-right: 24px;
    color: #2E31BE;
    font-size: 14px;
}
.errorHeading{
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    color: #EB5757;
    display: flex;
}

.apiErrorMessage{
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    color: #666666;
    margin: 12px 0px;
}
</style>
